/* eslint-disable react-hooks/exhaustive-deps */
import { faArrowRight, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { useContext } from "react";
import { Badge, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { AppRulesContext } from "../../App";
import { IEfilingDetailsData } from "../../config/interfaces";
import { loggedInUserSelector } from "../../redux/slice/LoggedInUserSlice";
import { useAppSelector } from "../../redux/Store";
import FASvgIcon from "../FASvgIcon";
import TablePagination from "../pagination/TablePagination";
import { TrackEFilingStatus } from "./../../config/filingConstants";

type Props = {
	filingsData: IEfilingDetailsData[];
	noRecords: boolean;
	handleRefresh: () => void;
	filter?: JSX.Element;
	pageCount: number;
	forcePage: number;
	handleOnPageChange: (event: any) => void;
};

const ITRFilingsForUser: React.FC<Props> = (props: Props) => {
	const { filingsData, noRecords = false, pageCount, forcePage, handleOnPageChange } = props;

	const navigate = useNavigate();
	const { loggedInUser } = useAppSelector(loggedInUserSelector);
	const { rulesSvc } = useContext(AppRulesContext);

	const getFileTrackingStatus = (status: string, userUuid: string) => {
		let _status = "";
		if (loggedInUser?.uuid === userUuid) {
			if (status === "EFILING_STATUS_REQUESTED_DETAILS") {
				_status = `${TrackEFilingStatus["EFILING_STATUS_REQUESTED_DETAILS_RECEIVED"]?.label}`;
			} else if (status === "EFILING_STATUS_RECEIVED_DETAILS") {
				_status = `${TrackEFilingStatus["EFILING_STATUS_DETAILS_SENT"]?.label}`;
			} else {
				_status = `${TrackEFilingStatus[status]?.label}`;
			}
		} else {
			_status = `${TrackEFilingStatus[status]?.label}`;
		}

		return _status;
	};

	return (
		<>
			<>
				{!noRecords ? (
					<>
						{filingsData.map((_filings, idx) => (
							<React.Fragment key={`${idx}`}>
								<div className="user-filing-listheader">
									<div className="left-side">
										<h3 className="user-name">{_filings?.name || "-"}</h3>
										<h4 className="user-pan">{_filings?.pan || "-"}</h4>
									</div>
									<div className="right-side">
										<h5 className="user-type">{_filings?.fileUsedBy || "-"}</h5>
									</div>
								</div>
								<Card className="list-card">
									<Card.Body>
										<section>
											<dl className="eds-list eds-dl eds-inline-between">
												{_filings?.EfilingData?.map((record, index) => (
													<div className="eds-list--item" key={`${index}`}>
														{rulesSvc.UserAndExpertStatusBadge.permissions?.includes(
															record.status
														) ? (
															<Badge
																bg={TrackEFilingStatus[record?.status]?.variant || ""}
																className={classNames(
																	"status-badge primary-para",
																	record.status
																		? `text-${TrackEFilingStatus[record?.status]?.bgTextColor}`
																		: null
																)}
																pill={true}
															>
																{getFileTrackingStatus(record.status, record.userUuid)}
															</Badge>
														) : null}

														<dt className="h4 fw-normal">
															Assessment Year
															<span className="fw-bold h5 ms-1">
																{record?.assessmentYear || "-"}
															</span>
															{record?.efilingPlan?.planData?.title && (
																<Badge bg="secondaryLight" className="text-white ms-3" pill={true}>
																	{record.efilingPlan.planData.title}
																</Badge>
															)}
														</dt>
														<dd className="primary-para fw-bold">
															<div className="badges-wrap">
																{!record?.efilingAuthorizedUser &&
																record?.efilingPlan &&
																!record?.efilingPlan?.inactive &&
																record?.efilingPlan?.planData?.type === "assisted" ? (
																	<Badge bg="warning" className="primary-para" pill={true}>
																		Awaiting a Tax Expert
																	</Badge>
																) : null}

																{!record?.efilingAuthorizedUser &&
																record?.efilingPlan &&
																record?.efilingPlan?.inactive ? (
																	<Badge bg="warning" className="primary-para" pill={true}>
																		Payment Pending
																	</Badge>
																) : null}

																{record?.efilingPlan?.efilingPlanTransaction?.orderStatus && (
																	<Badge
																		bg="success"
																		className="primary-para text-capitalize"
																		pill={true}
																	>
																		{record?.efilingPlan?.efilingPlanTransaction?.orderStatus}
																	</Badge>
																)}
															</div>

															{!record?.efilingPlan ? (
																<Button
																	variant="link"
																	className="text-secondary"
																	onClick={() => {
																		navigate(`/itr-filings/${record?.uuid}/assisted/plans`, {
																			state: { sourceScreen: "assisted" }
																		});
																	}}
																>
																	Get expert assistance
																</Button>
															) : null}

															{record?.efilingAuthorizedUser &&
															record?.efilingPlan &&
															!record?.efilingPlan?.inactive &&
															record?.efilingPlan?.planData?.type === "assisted" ? (
																<Button
																	className="icon-only msg-btn"
																	variant="transparent"
																	onClick={() => {
																		navigate(`/itr-filings/${record?.uuid}`);
																	}}
																>
																	<FASvgIcon icon={faEnvelope}></FASvgIcon>
																	<span className="new-msg" />
																</Button>
															) : null}

															{!record?.completedAt ? (
																<Button
																	size="sm"
																	type="button"
																	variant="primary"
																	className="btn-w-140 text-white"
																	onClick={() => {
																		navigate(`/itr-filings/${record?.uuid}`);
																	}}
																>
																	Proceed <FASvgIcon icon={faArrowRight} />
																</Button>
															) : null}

															{record?.completedAt ? (
																<Button
																	size="sm"
																	type="button"
																	variant="outline-greyDark"
																	className="btn-w-140"
																	onClick={() => {
																		navigate(`/itr-filings/${record?.uuid}`);
																	}}
																>
																	Completed
																</Button>
															) : null}
														</dd>
													</div>
												))}
											</dl>
										</section>
									</Card.Body>
								</Card>
							</React.Fragment>
						))}
					</>
				) : (
					<Card className="list-card">
						<Card.Body>
							<section>
								<dl className="eds-list eds-dl eds-inline-between">
									<div className="eds-list--item justify-content-center">
										<dt className="h4 fw-normal">No Data Found</dt>
									</div>
								</dl>
							</section>
						</Card.Body>
					</Card>
				)}
			</>

			{!noRecords && (
				<TablePagination
					pageCount={pageCount}
					pageOffset={forcePage}
					handleOnPageChange={handleOnPageChange}
				/>
			)}
		</>
	);
};

export default ITRFilingsForUser;
